import SectionTitle from "./SectionTitle";
import { cantWatchCauses, cantWatchSteps } from "@/mocks/home";

export default function CantWatch() {
  return (
    <section id="cant-watch" className="bg-background-100 border-y border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionTitle
          eyebrow="看不了怎么办"
          title="西瓜影院在线观看打不开？按这个顺序排查"
          desc="先分清是线路问题还是本地问题，再逐条排除，绝大多数“看不了”都能在几分钟内解决。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-10">
          <ol className="lg:col-span-2 space-y-4">
            {cantWatchSteps.map((s) => (
              <li
                key={s.step}
                className="flex gap-4 rounded-lg bg-background-50 border border-background-200 p-5"
              >
                <span
                  className="shrink-0 w-11 h-11 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-base font-bold"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  {s.step}
                </span>
                <div>
                  <h3 className="text-base font-semibold text-foreground-950">{s.title}</h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
                </div>
              </li>
            ))}
          </ol>

          <aside className="rounded-lg bg-background-50 border border-background-200 p-6 h-fit">
            <h3 className="flex items-center gap-2 text-base font-semibold text-foreground-950 mb-4">
              <i className="ri-stethoscope-line text-accent-600" aria-hidden="true"></i>
              先判断是哪种“看不了”
            </h3>
            <ul className="space-y-4">
              {cantWatchCauses.map((c) => (
                <li key={c.title} className="border-l-2 border-accent-300 pl-3">
                  <p className="text-sm font-medium text-foreground-900">{c.title}</p>
                  <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{c.desc}</p>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}